let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5audb")).then(() => parcelRequire('c6bSy'));